var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 137,
    viewBox: "0 0 139 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_220_11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.5,
    cy: 64.5,
    rx: 65.5,
    ry: 64.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9449 33.1013L75.6428 36.2902C76.0245 36.8787 76.438 37.3996 76.9251 37.8847C78.3532 39.2949 79.6842 40.8 80.9093 42.3898C83.7861 46.1672 85.7265 50.3621 87.1122 54.8989C87.9433 57.6703 88.3946 60.5133 88.4284 63.3881C88.5675 71.9827 85.6211 79.3626 79.6807 85.4959C78.7144 86.4685 77.6705 87.3608 76.5593 88.1639C75.9708 88.1639 75.6925 87.7126 75.4499 87.2971C75.0082 86.5266 74.7143 85.6804 74.5831 84.802C74.3744 83.7623 74.2372 82.7225 74.3048 81.6489V81.1638C74.2571 81.0604 73.7382 33.3459 73.9449 33.1013Z",
    fill: "#599636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9454 32.9959C73.8758 32.8567 73.8062 32.9621 73.7366 33.0297C73.7704 33.7255 73.5279 34.3458 73.1481 34.9383C72.7306 35.5267 72.1779 35.978 71.6233 36.4631C68.5417 39.1312 66.1162 42.3539 64.1738 45.9584C61.5893 50.8093 60.2572 56.0082 59.8795 61.4815C59.7065 63.4557 60.5037 70.422 61.126 72.432C62.8239 77.7681 65.8736 82.2393 69.824 86.1201C70.7942 87.0545 71.832 87.9213 72.9056 88.7544C73.2177 88.7544 73.2515 88.476 73.3231 88.2693C73.4599 87.8268 73.5643 87.375 73.6352 86.9174L74.3311 81.7204L73.9454 32.9959Z",
    fill: "#6CAC48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6439 90.2753C75.7135 89.48 76.0952 88.82 76.5107 88.1619C76.0932 87.9889 75.783 87.645 75.5405 87.2613C75.3314 86.898 75.1582 86.5151 75.0236 86.1181C74.5385 84.6629 74.4351 83.136 74.2959 81.6489V80.7483C74.123 80.8875 74.0872 82.0644 74.0872 82.2394C73.986 83.8111 73.7774 85.3741 73.4629 86.9174C73.3595 87.5416 73.29 88.1639 72.9062 88.7186C72.9062 88.7882 72.9063 88.8577 72.94 88.9611C73.5643 90.7981 73.7353 92.6689 73.8407 94.5755V95.2713C73.8407 96.1024 73.8069 95.9274 74.4967 96.2058C74.7751 96.3091 75.0852 96.3449 75.3636 96.5517C75.5723 96.5517 75.6061 96.3787 75.6061 96.2396L75.5027 95.0964V91.9075C75.4689 91.3508 75.5723 90.7981 75.6419 90.2772L75.6439 90.2753Z",
    fill: "#C2BFBF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_220_11",
    x: 0,
    y: 0,
    width: 139,
    height: 137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_220_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_220_11",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.98d8bfc503c8041eac0106ecebc64981.svg";
export { ForwardRef as ReactComponent };